import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import noop from 'lodash/noop';
import {
  canManageSubscription as canManageSubscriptionSelector,
  getSubscription,
  getSubscriptionStatus,
} from '../../selectors';
import { fetchInvoices, payInvoice } from '../actions';
import Date from '../../../../common/date';
import Money from '../../../../common/money';
import { getShopBrandId } from '../../../../auth/selectors';

const Invoices = (props) => {
  const { brandId, canManageSubscription, dispatch, subscriptionStatus } = props;

  const chargeInvoice = invoiceId => () => {
    // Handle the output of dispatch so that we don't get 'uncaught in promise' errors,
    // But ignore the output, as the reducer is controlling all the logic.
    const { subscriptionId } = subscriptionStatus;

    dispatch(payInvoice(brandId, subscriptionId, invoiceId)).then(noop, noop);
  };

  const getStatusClass = (status) => {
    switch (status) {
      case 'paid':
        return 'u-font-color-green';

      case 'refunded':
        return 'u-font-color-blue';

      default:
        return 'u-font-color-red';
    }
  };

  useEffect(() => {
    if (subscriptionStatus && canManageSubscription) {
      dispatch(fetchInvoices(subscriptionStatus.subscriptionId));
    }
  }, []);

  useEffect(() => {
    const newSubscriptionId = get(props, 'subscriptionStatus.subscriptionId');

    if (newSubscriptionId && canManageSubscription) {
      dispatch(fetchInvoices(newSubscriptionId));
    }
  }, [subscriptionStatus]);

  if (!canManageSubscription) {
    return null;
  }

  const db = props.invoices;
  const invoices = db.rows || [];

  return (
    <div className="c-inner-wrapper u-max-width-710 u-mt">
      <h5>Invoices</h5>
      <table className="u-mt- c-heading c-heading--small">
        <thead>
          <tr>
            <th className="c-label u-text-left u-pb-">Date</th>
            <th className="c-label u-text-left u-pb-">Status</th>
            <th className="c-label u-text-left u-pb-">Amount</th>
            <th className="c-label u-text-left u-pb-">Card</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {invoices.map(i => <tr key={i.id}>
            <td><Date>{i.createdAt}</Date></td>
            <td className={getStatusClass(i.status)}>{i.status}</td>
            <td>
              <Money cents={i.total} currency={i.currency} />
            </td>
            <td>{i.brand} **** {i.last4}</td>
            <td>
              <button
                type="button"
                className="c-btn c-btn--outline c-btn--small"
                onClick={chargeInvoice(i.id)}
                display-if={i.status !== 'paid'}
              >
              Charge now
            </button>
            </td>
          </tr>)}
        </tbody>
      </table>
    </div>
  );
};

Invoices.propTypes = {
  brandId: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  invoices: PropTypes.object.isRequired,
  subscriptionStatus: PropTypes.object.isRequired,
  canManageSubscription: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  brandId: getShopBrandId(state),
  invoices: getSubscription(state).invoices,
  subscriptionStatus: getSubscriptionStatus(state),
  canManageSubscription: canManageSubscriptionSelector(state),
});

export default connect(mapStateToProps)(Invoices);
